var _defs, _mask, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_reload_svg__a",
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_reload_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_reload_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_reload_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.01 11.025l-1.848.766a10.95 10.95 0 010 8.418 10.965 10.965 0 01-5.953 5.954 10.99 10.99 0 01-4.133.84 11.093 11.093 0 01-4.286-.84 10.94 10.94 0 01-3.625-2.437 10.977 10.977 0 01-2.328-3.517 10.965 10.965 0 010-8.418 10.975 10.975 0 015.953-5.954 10.99 10.99 0 014.133-.84c1.485.011 2.914.272 4.286.84.688.285 1.337.633 1.944 1.042l-1.872.246.261 1.983 5.126-.675-.675-5.126-1.983.261.214 1.624a13.037 13.037 0 00-2.25-1.203c-1.62-.67-3.313-.986-5.066-.992a12.979 12.979 0 00-4.883.992A12.944 12.944 0 006.87 6.741a12.911 12.911 0 00-2.88 4.284 12.964 12.964 0 000 9.95 12.942 12.942 0 002.75 4.154 12.926 12.926 0 004.285 2.881c1.591.66 3.262.993 4.968.993h.098a12.96 12.96 0 004.883-.993 12.936 12.936 0 004.155-2.75 12.916 12.916 0 002.881-4.286 12.956 12.956 0 000-9.949"
  })))));
}

export default SvgIconReload;